import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Route, Switch, Redirect } from "react-router-dom";

import Header from "./components/header";
import Footer from "./components/footer";

import Login from "./login";
import ForgotPassword from "./forgot-password";
import ResetPassword from "./reset-password";
import Logout from "./logout";
import VerifyEmail from "./verify-email";

import fetch from "../../utils/fetch";

import { useMetatagStore } from "../../store/metatag";
import { useAuthStore } from "../../store/auth";

const metatags = require("../../datasets/metatags.json");

interface Props {}

const Auth: React.FC<Props> = () => {
    const metatag = useMetatagStore<any>((s) => s.metatag);
    const setMetatag = useMetatagStore<any>((s) => s.setMetatag);
    const setloggedIn = useAuthStore<any>((s) => s.setloggedIn);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const path = window.location.pathname.replace(/\/$/, "");

        if (path !== metatag?.route) {
            const split = path.split("/");
            if (split.length >= 3 && split[1] === "reset-password" && split[2].length === 36) {
                setMetatag(metatags["/reset-password"]);
            } else {
                setMetatag(metatags[path]);
            }
        }
    });

    useEffect(() => {
        const auth = new fetch(null, {}, { success: false, error: true }).auth();
        auth.then(async (res) => {
            if (res.status === "success" && res.auth.logged_in === true) {
                setloggedIn(true);
            } else {
                setloggedIn(false);
            }
            if (window.location.pathname.split("/")[1] === "dashboard") {
                setLoading(true);
            }
        }).catch(() => {
            setloggedIn(false);
            if (window.location.pathname.split("/")[1] === "dashboard") {
                setLoading(true);
            }
        });
    }, []);

    return (
        <>
            <div id="auth">
                <Switch>
                    <Route path="/login" render={() => <Login footer={<Footer />} />} exact />
                    <Route path="/logout" render={() => <Logout />} exact />
                    <Route path="/forgot-password" render={() => <ForgotPassword footer={<Footer />} />} exact />
                    <Route path="/reset-password/:id" render={() => <ResetPassword footer={<Footer />} />} exact />
                    <Route path="/verify-email/:id" render={() => <VerifyEmail />} exact />
                    <Redirect to="/404" />
                </Switch>
            </div>
        </>
    );
};

export default Auth;
